// extracted by mini-css-extract-plugin
module.exports = {"container":"TruContent_container__3_0zu","frame":"TruContent_frame__3tdBI","spin":"TruContent_spin__YGoDp"};